import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { provideBackendToken } from "@/shared/lib/authorization/provide-backend-token";
import { reAuthOn401Wrapper } from "@/services/backend/_lib/re-auth-on-401";

export const backendApi = createApi({
  baseQuery: reAuthOn401Wrapper(
    fetchBaseQuery({
      baseUrl: import.meta.env.VITE_BACKEND_URL,
      prepareHeaders: async (headers) => {
        const accessToken: string = await provideBackendToken();
        headers.set("Authorization", `Bearer ${accessToken}`);
        return headers;
      },
    }),
  ),
  endpoints: () => ({}),
  reducerPath: "backendApi",
  tagTypes: [
    "AuthEntraGroup",
    "Branch",
    "BranchMatch",
    "Calculations",
    "CommentsComment",
    "Company",
    "CompanyMatch",
    "CompanyProfile",
    "ContactKind",
    "Customer",
    "CustomersServiceObject",
    "Document",
    "HtzAirHandlingUnitData",
    "HtzOffer",
    "HtzOrder",
    "HtzConfirmation",
    "HtzWorkOrder",
    "HtzWorkOrderPosition",
    "HtzReport",
    "NumbersDocumentNumber",
    "Process",
    "ServiceContactKindMatch",
    "ProcessContactRoleMatch",
    "SamplesSampleViewModel",
    "ServiceKindMatch",
    "OutboxGesecInvoice",
    "ProcessState",
    "Textblock", // needed globally, since invalidated from multiple places (cpy)
    "TextblocksDefaultCatalog",
    "RltCalculation",
    "RltCertificate",
    "RltConfirmation",
    "RltContract",
    "RltDefaults",
    "RltDocumentation",
    "RltLMRA",
    "RltOffer",
    "RltOrder",
    "RltPricing",
    "RltPricingByArea",
    "RltTreatment",
    "RltWorkOrder",
    "RelationshipsRelationship", // needed globally, since invalidated from multiple places
    "RelationshipsRelationshipCommitment", // needed globally, since invalidated from multiple places
    "RelationshipsFulfillment", // needed globally, since invalidated from multiple places
    "VbsCalculation",
    "VbsCertificate",
    "VbsConfirmation",
    "VbsContract",
    "VbsDefaults",
    "VbsDocumentation",
    "VbsLMRA",
    "VbsOffer",
    "VbsOrder",
    "VbsPricing",
    "VbsPricingByArea",
    "VbsTreatment",
    "VbsWorkOrder",
  ],
});
